<template>
    <div id="app">
        <router-view />
        <depositPopup></depositPopup>
        <withdrawPopup></withdrawPopup>
        <bankSet></bankSet>
        <withdrawPwdSetPopup></withdrawPwdSetPopup>
        <loadingPopup></loadingPopup>
    </div>
</template>
<script>
import { getSysBaseConfig, telegramLogin } from '@/api/system'
import { getUserInfo } from '@/api/user'
// import { domain } from '@/common/http'
import { getPWAValue } from '@/api/pwa'
import { isPWA, getPlatform } from '@/utils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
    created() {
        this.$i18n.locale = this.$store.getters.language
        const equipmentId = this.$store.state.system.equipmentId
        if (!equipmentId) this.getBrowserFingerprint()
    },
    mounted() {
        const that = this
        if (!this.$store.getters.invitCode && getPlatform() === 'ios' && isPWA()) this.getPWAValue()

        getSysBaseConfig().then((res) => {
            if (!res || res.code || !res.result || typeof res.result !== 'object') return
            const D = res.result
            this.$store.dispatch('system/setSysConfig', D)
            if (D.belongCountry && (!this.$store.state.system.userSetlanguage)) {
                this.$store.dispatch('system/setLanguage', D.belongCountry)
                this.$i18n.locale = D.belongCountry
            }
            try {
                const link = document.querySelector("link[rel*='icon']")
                if (link) link.href = D.homeImageUrl
                // document.querySelector('meta[property="og:title"]').setAttribute('content', D.projectName)
                // document.querySelector('meta[property="og:url"]').setAttribute('content', domain)
                // document.querySelector('meta[property="og:image"]').setAttribute('content', D.homeLogoUrl)
                // document.querySelector('meta[property="og:description"]').setAttribute('content', D.projectName)
            } catch (e) {
                console.log(e)
            }
        })
        try {
            const token = this.$store.getters.token
            if (token) {
                getUserInfo().then((uInfo) => {
                    if (!uInfo || uInfo.code) return
                    that.$websocket.initWebSocket()
                })
            } else {
                this.$websocket.close()
            }
        } catch (e) {
            console.log(e)
        }
        try {
            let isInstallPWA = 2
            if ('serviceWorker' in navigator) {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    that.$store.dispatch('system/setIsShowDownAppNav', 1)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 1)
                    isInstallPWA = 1
                    console.log('PWA未安装555555')
                })
                if (isInstallPWA === 2) {
                    console.log('PWA已经安装666666')
                    if (getPlatform() === 'ios') return
                    that.$store.dispatch('system/setIsShowDownAppNav', 2)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
                }
            } else {
                console.log('Service Worker 不受此浏览器支持')
                // that.$store.dispatch('system/setIsShowDownAppNav', 1)
                that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
            }
        } catch (e) {
            console.log(e, 'PWA错误')
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload)

        that.telegramLogin()
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
    },
    methods: {
        handleBeforeUnload(event) {
            this.$websocket.close()
            console.log('浏览器即将关闭', event)
        },
        getPWAValue() {
            const that = this
            const userAgent = navigator.userAgent
            const params = { userAgent }
            getPWAValue(params).then((res) => {
                if (!res || res.code || !res.result) return
                const D = res.result
                that.$store.dispatch('user/setInvitCode', D.invitationCode)
                that.$store.dispatch('system/setPixel', D.trafficAcquisitionType)
                that.$store.dispatch('system/setTaId', D.taid)
                that.$store.dispatch('system/setClickId', D.clickId)
                that.$store.dispatch('user/setInvitCodeNum', 1)
                if (that.$store?.getters.invitCode && (!that.$store?.getters.token) && that.$store?.getters.invitCodeNum === 1) {
                    console.log(66666)
                    that.$store.dispatch('user/setInvitCodeNum', 2)
                    that.$store.dispatch('user/changeLoginType', 1)
                    that.$store.dispatch('user/setIsShowLoginPopup', true)
                }
            })
        },
        telegramLogin() {
            const WebApp = window.Telegram?.WebApp
            if (!WebApp) return
            WebApp.ready()
            const user = WebApp.initDataUnsafe.user
            if (user) {
                this.$store.commit('user/SET_TOKEN', '')
                const initData = WebApp.initData
                const params = JSON.stringify({ initData: initData })
                telegramLogin(params).then((res) => {
                    if (res?.code === 0) {
                        this.$store.dispatch('user/setInvitCode', '')
                        this.$store.dispatch('system/setTelegramUserId', '')
                        this.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                        this.$forceUpdate()
                        getUserInfo().then((uInfo) => {
                            if (!uInfo || uInfo.code) return
                            this.$websocket.initWebSocket()
                        })
                        this.$store.dispatch('user/setIsShowLoginPopup', false)
                    }
                    if (res?.code === 401) {
                        this.$store.dispatch('system/setTelegramUserId', res.result.telegramUserId)
                    }
                })
            }
        },
        async getBrowserFingerprint() {
            let browserFinger
            try {
                const fp = await FingerprintJS.load()
                const result = await fp.get()
                browserFinger = result.visitorId
            } catch (error) {
                browserFinger = 'default123456789'
            }
            this.$store.dispatch('system/setEquipmentId', browserFinger)
        }
    }
}
</script>
<style lang="scss" src="./common/styles/aurora.scss"></style>
